import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import OurSolutions from "./pages/OurSolutions";
import Projects from "./pages/Projects";
import JoinUs from "./pages/JoinUs";

import Login from "./auth/Login";
import Register from "./auth/Register";

import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";

import DashboardLayout from "./layout/DashboardLayout";
import OrderDetails from "./admin/OrderDetails.jsx";
import Dashboard from "./admin/Dashboard";
import ProductList from "./admin/ProductList";
import AddProduct from "./admin/AddProduct.jsx";
import EditProduct from "./admin/EditProduct";
import Categories from "./admin/Categories";
import Orders from "./admin/Orders";
import Inventory from "./admin/Inventory";
import Productpage from "./pages/products/Productpage.jsx";
import Settings from "./admin/Settings";
import PageNotFound from "./pages/PageNotFound";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/products/Cart";
import Checkout from "./pages/products/Checkout";
import OrderSuccess from "./pages/products/OrderSuccess";
import Payment from "./pages/products/Payment";
import MyOrders from "./Buyer/MyOrders.jsx";
import BuyerLayout from "./layout/BuyerLayout.jsx";
import BuyerDashboard from "./Buyer/BuyerDashboard.jsx";
import Profile from "./Buyer/Profile.jsx";
import BuyerSettings from "./Buyer/Settings.jsx";
import BuyerOrderDetails from "./Buyer/Settings.jsx";
import Query from "./admin/Query.jsx";
import ReturnRequests from "./admin/ReturnRequests.jsx";
import WhatsAppButton from "./components/WhatsAppButton";
import Products from "./pages/Products.jsx";
import Technology from "./pages/Technology.jsx";
import Blog from "./pages/Bloge.jsx";
import Blogdetails from "./pages/BlogDetails.jsx";
import ContactUs from "./pages/Contact.jsx";
import SolutionDetails from "./pages/SolutionDetails";
import ComingSoon from "./pages/ComingSoon.jsx";
// import MyOrders from "./Buyer/My-Orders.jsx";
function Layout() {
  return (
    <>
      <Navbar />

      <Routes>
        {/* Website */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        {/* =============================web page======================================= */}
        <Route path="/solutions" element={<OurSolutions />} />

        <Route path="/our-product" element={<Products />} />

        <Route
          path="/products"
          element={
            <Products />
          }
        />

        <Route path="/technology" element={<Technology />} />

        <Route path="/our-fruits-and-vegetables" element={<Products />} />

        <Route
          path="/blog"
          element={
            <Blog />
          }
        />

        <Route path="/blog/:slug" element={<Blogdetails />} />

        <Route path="/products/:slug" element={<ProductDetails />} />

        <Route path="/solutions/:slug" element={<SolutionDetails />} />
        {/* =============================web page============================================= */}
        <Route path="/projects" element={<Projects />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/order-success" element={<OrderSuccess />} />

        <Route path="/contact" element={<ContactUs />} />
        {/* Dashboard admin*/}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="orders/:orderId" element={<OrderDetails />} />
          <Route path="products" element={<ProductList />} />
          <Route path="categories" element={<Categories />} />
          <Route path="query" element={<Query />} />
          <Route path="orders" element={<Orders />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="settings" element={<Settings />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route path="edit-product/:slug" element={<EditProduct />} />
          <Route path="return" element={<ReturnRequests />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
        {/* Dashboard buyer*/}
        <Route path="/buyer" element={<BuyerLayout />}>
          <Route index element={<BuyerDashboard />} />
          <Route path="my-orders" element={<MyOrders />} />
          <Route path="profile" element={<Profile />} />
          <Route path="cart" element={<Cart />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="orders/:orderId" element={<OrderDetails />} />
          <Route path="settings" element={<BuyerSettings />} />
        </Route>

        <Route path="*" element={<PageNotFound />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
      <WhatsAppButton />
    </>
  );
}

export default App;
